// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `th {
    font-size: 1vw;
    font-weight: normal;
    text-align: left;
    padding: 20px;
    border-style: none;
    white-space: nowrap;
    /*width: 40px;*/
}

td {
    border-style: none;
    text-align: center;
    width: 100px;
}

tr {
    border-bottom: 1px solid lightgrey;
    /*width: 40px;*/

}

table {
    border-collapse: collapse;
    border: 1px solid lightgrey;
    overflow: hidden;
    border-radius: 12px;
    box-shadow: 0 0 8px 4px rgba(96, 96, 255, 0.25);
}

.style__cell___Qz1rM {
    background: rgba(255,0,0,0.1);
    margin: 4px;
    padding-top: 4px;
    padding-bottom: 4px;
    border-radius: 4px;
}

@media screen and (max-width: 1100px) {
    th {
        font-size: 4.5vw;
    }
    table {
        overflow: auto;
        box-shadow: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Table/style.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,eAAe;;AAEnB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB,+CAA+C;AACnD;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,cAAc;QACd,gBAAgB;IACpB;AACJ","sourcesContent":["th {\n    font-size: 1vw;\n    font-weight: normal;\n    text-align: left;\n    padding: 20px;\n    border-style: none;\n    white-space: nowrap;\n    /*width: 40px;*/\n}\n\ntd {\n    border-style: none;\n    text-align: center;\n    width: 100px;\n}\n\ntr {\n    border-bottom: 1px solid lightgrey;\n    /*width: 40px;*/\n\n}\n\ntable {\n    border-collapse: collapse;\n    border: 1px solid lightgrey;\n    overflow: hidden;\n    border-radius: 12px;\n    box-shadow: 0 0 8px 4px rgba(96, 96, 255, 0.25);\n}\n\n.cell {\n    background: rgba(255,0,0,0.1);\n    margin: 4px;\n    padding-top: 4px;\n    padding-bottom: 4px;\n    border-radius: 4px;\n}\n\n@media screen and (max-width: 1100px) {\n    th {\n        font-size: 4.5vw;\n    }\n    table {\n        overflow: auto;\n        box-shadow: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cell": `style__cell___Qz1rM`
};
export default ___CSS_LOADER_EXPORT___;
